import { Route, Switch, useLocation, useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { colorBackgroundBody } from '@spark/ui-components/theme';
import { paddingLeft } from '@spark/ui-components/theme';
import styled from 'styled-components';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@spark/ui-components/components/Button';
import { CognitoAuth } from '@spark/ui-components/components';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import PrivateRoute from './PrivateRoute';
import NotFound from '../../containers/DefaultPage/404/index';
import ProtectedRoute from '@spark/ui-components/components/ProtectedRoute';

import DashboardOuvidoria from '../DashboardOuvidoria/index';

import VagasProcessoEmAbertoMain from '../VagasProcessoEmAberto/Listagem/index';
import VagasProcessoEmAbertoCadastro from '../VagasProcessoEmAberto/Cadastro/index';
import VagasProcessoEmAbertoDetalhes from '../VagasProcessoEmAberto/Detalhes/index';

import VagasProcessoEncerradosMain from '../VagasProcessoEncerrados/Listagem/index';
import VagasProcessoEncerradosCadastro from '../VagasProcessoEncerrados/Cadastro/index';
import VagasProcessoEncerradosDetalhes from '../VagasProcessoEncerrados/Detalhes/index';

import BeneficiosMain from '../Beneficios/Listagem/index';
import BeneficiosCadastro from '../Beneficios/Cadastro/index';
import BeneficiosDetalhes from '../Beneficios/Detalhes/index';

import MotivosOuvidoriaMain from '../MotivosOuvidoria/Listagem/index';
import MotivosOuvidoriaCadastro from '../MotivosOuvidoria/Cadastro/index';
import MotivosOuvidoriaDetalhes from '../MotivosOuvidoria/Detalhes/index';
import OuvidoriaMain from '../Ouvidoria/Listagem/index';
import OuvidoriaCadastro from '../Ouvidoria/Cadastro/index';
import OuvidoriaDetalhes from '../Ouvidoria/Detalhes/index';
import TagsOuvidoriaMain from '../TasgOuvidoria/Listagem/index';
import TagsOuvidoriaCadastro from '../TasgOuvidoria/Cadastro/index';
import TagsOuvidoriaDetalhes from '../TasgOuvidoria/Detalhes/index';
import FiliaisOuvidoriaMain from '../FiliaisOuvidoria/Listagem/index';
import FiliaisOuvidoriaCadastro from '../FiliaisOuvidoria/Cadastro/index';
import FiliaisOuvidoriaDetalhes from '../FiliaisOuvidoria/Detalhes/index';

import CandidatoMain from '../Candidato/Listagem/index';
import CandidatoDetalhes from '../Candidato/Detalhes/index'; 
import CandidatoCadastro from '../Candidato/Cadastro/index';

const Pages = () => <Switch>

  {
    /* Rotas de Dashboard */
  }
  <ProtectedRoute exact path="/pages" component={DashboardOuvidoria} />
  {/* <ProtectedRoute exact path="/pages" component={Dashboard} /> */}
  <ProtectedRoute exact path="/pages/dashboard-ouvidoria" component={DashboardOuvidoria} />

  {
    /* Rotas de Processos em Aberto */
  }
  <ProtectedRoute exact path="/pages/vagas/processosemaberto" component={VagasProcessoEmAbertoMain} />
  <ProtectedRoute path="/pages/vagas/processosemaberto/criar" component={VagasProcessoEmAbertoCadastro} />
  <ProtectedRoute path="/pages/vagas/processosemaberto/editar/:id" component={VagasProcessoEmAbertoCadastro} />
  <ProtectedRoute path="/pages/vagas/processosemaberto/:id" component={VagasProcessoEmAbertoDetalhes} />

  {
    /* Rotas de Processos Encerrados */
  }
  <ProtectedRoute exact path="/pages/vagas/processosencerrados" component={VagasProcessoEncerradosMain} />
  <ProtectedRoute path="/pages/vagas/processosencerrados/criar" component={VagasProcessoEncerradosCadastro} />
  <ProtectedRoute path="/pages/vagas/processosencerrados/editar/:id" component={VagasProcessoEncerradosCadastro} />
  <ProtectedRoute path="/pages/vagas/processosencerrados/:id" component={VagasProcessoEncerradosDetalhes} />

  {
    /* Rotas de Beneficios */
  }
  <ProtectedRoute exact path="/pages/beneficios" component={BeneficiosMain} />
  <ProtectedRoute path="/pages/beneficios/criar" component={BeneficiosCadastro} />
  <ProtectedRoute path="/pages/beneficios/editar/:id" component={BeneficiosCadastro} />
  <ProtectedRoute path="/pages/beneficios/:id" component={BeneficiosDetalhes} />

  {
    /* Rotas de Ouvidoria */
  }
  <ProtectedRoute exact path="/pages/ouvidoria" component={OuvidoriaMain} />
  <ProtectedRoute path="/pages/ouvidoria/criar" component={OuvidoriaCadastro} />
  <ProtectedRoute path="/pages/ouvidoria/editar/:id" component={OuvidoriaCadastro} />
  <ProtectedRoute path="/pages/ouvidoria/:id" component={OuvidoriaDetalhes} />

  {
    /* Rotas de Motivos da Ouvidoria */
  }
  <ProtectedRoute exact path="/pages/motivoouvidoria" component={MotivosOuvidoriaMain} />
  <ProtectedRoute path="/pages/motivoouvidoria/criar" component={MotivosOuvidoriaCadastro} />
  <ProtectedRoute path="/pages/motivoouvidoria/editar/:id" component={MotivosOuvidoriaCadastro} />
  <ProtectedRoute path="/pages/motivoouvidoria/:id" component={MotivosOuvidoriaDetalhes} />

  {
    /* Rotas de Tags da Ouvidoria */
  }
  <ProtectedRoute exact path="/pages/tagsouvidoria" component={TagsOuvidoriaMain} />
  <ProtectedRoute path="/pages/tagsouvidoria/criar" component={TagsOuvidoriaCadastro} />
  <ProtectedRoute path="/pages/tagsouvidoria/editar/:id" component={TagsOuvidoriaCadastro} />
  <ProtectedRoute path="/pages/tagsouvidoria/:id" component={TagsOuvidoriaDetalhes} />

  {
    /* Rotas de Filiais da Ouvidoria */
  }
  <ProtectedRoute exact path="/pages/filiaisouvidoria" component={FiliaisOuvidoriaMain} />
  <ProtectedRoute path="/pages/filiaisouvidoria/criar" component={FiliaisOuvidoriaCadastro} />
  <ProtectedRoute
    path="/pages/filiaisouvidoria/editar/:id"
    component={FiliaisOuvidoriaCadastro}
  />
  <ProtectedRoute path="/pages/filiaisouvidoria/:id" component={FiliaisOuvidoriaDetalhes} />

  {
    /* Rotas de Curriculos */
  }
  <ProtectedRoute exact path="/pages/candidato" component={CandidatoMain} />
  <ProtectedRoute path="/pages/candidato/criar" component={CandidatoCadastro} />
  <ProtectedRoute path="/pages/candidato/editar/:id" component={CandidatoCadastro} />
  <ProtectedRoute path="/pages/candidato/:id" component={CandidatoDetalhes} />

  <Route component={NotFound} />
</Switch>;

const WrappedRoutes = () => {
  const location = useLocation();
  const history = useHistory();
  const {
    user,
    loading
  } = useAuth();
  const isPersonalizado = location.pathname.includes('/detalhesdisponibilidade/personalizado/'); // Se ainda está carregando, mostra loading

  if (loading) {
    return <div>Carregando...</div>;
  } // Usuário externo só pode acessar telas personalizadas


  if (user?.isExternalUser && !isPersonalizado) {
    return <div style={{
      padding: '50px',
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '500px'
      }}>
        <h2 style={{
          color: '#dc3545',
          marginBottom: '20px'
        }}>🚫 Acesso Restrito</h2>
        <p style={{
          marginBottom: '15px',
          color: '#6c757d'
        }}>
          Você está acessando como usuário externo e não tem permissão para esta área.
        </p>
        <p style={{
          marginBottom: '25px',
          color: '#6c757d'
        }}>
          Para acessar todas as funcionalidades, faça login com sua conta @transben.com.br
        </p>
        <div style={{
          display: 'flex',
          gap: '15px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <Button variant="primary" onClick={() => history.push('/log_in')} style={{
            minWidth: '120px'
          }}>
            Fazer Login
          </Button>
          <Button variant="secondary" onClick={() => window.close()} style={{
            minWidth: '120px'
          }}>
            Fechar
          </Button>
        </div>
      </div>
    </div>;
  }

  const Container = isPersonalizado ? ContainerFullPage : ContainerWithLayout;
  return <div>
    {!isPersonalizado && <Layout />}
    <Container>
      <Pages />
    </Container>
  </div>;
};

const Router = () => {
  const location = useLocation();
  const {
    loginWithToken
  } = useAuth();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encryptedToken = params.get('tk');

    if (encryptedToken) {
      const processedToken = localStorage.getItem('processedToken');

      if (processedToken === encryptedToken) {

        return;
      }

      const success = loginWithToken(encryptedToken);

      if (success) {
        // Marca o token como processado
        localStorage.setItem('processedToken', encryptedToken);

        const cleanUrl = location.pathname;
        window.history.replaceState({}, '', cleanUrl);
      }
    }
  }, [location.pathname, location.search, loginWithToken]);
  return <MainWrapper>
    <main>
      <Switch>
        <Route
          exact
          path={['/', '/log_in']}
          render={() => <CognitoAuth redirectPath="/pages/dashboard-ouvidoria" subhead="Sistema RH" />}
        />
        <PrivateRoute path="/pages" component={WrappedRoutes} />
        <Route component={NotFound} />
      </Switch>
    </main>
  </MainWrapper>;
};

export default Router; // region STYLES

const ContainerWithLayout = styled.div`
  padding-top: 90px;
  min-height: 100vh;
  transition: padding-left 0.3s;
  background: ${colorBackgroundBody};
  ${paddingLeft}: 0;

  @media screen and (min-width: 576px) {
    ${paddingLeft}: 250px;
  }

  @media screen and (max-width: 576px) {
    padding-top: 70px;
  }
`;
const ContainerFullPage = styled.div`
  padding: 0;
  min-height: 100vh;
  background: ${colorBackgroundBody};
`; // endregion
